import '@availity/yup';
import * as yup from 'yup';

const formValidation = yup.object().shape({
  name: yup.string().required(),
  supplierType: yup.string().required(),
});

export default formValidation;
